import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=0047f719&"
import script from "./premium.vue?vue&type=script&lang=js&"
export * from "./premium.vue?vue&type=script&lang=js&"
import style0 from "./premium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports